import React, { useState } from 'react';
import './Search.css';
import SearchIcon from '@mui/icons-material/Search';
import MicIcon from '@mui/icons-material/Mic';
import { useNavigate } from 'react-router-dom';
import { useStateValue } from "../StateProvider.js";
import { actionTypes } from "../reducer.js";


function Search({hideButtons = false}) {
   // const [{}, dispatch] = useStateValue();

    let history = useNavigate();
    const [input, setInput] =useState("")


    const search = event =>{  // prevents refresh


        // dispatch({
        //     type: actionTypes.SET_SEARCH_TERM,
        //     term: input
        
        // })
        localStorage.setItem("seachTerm", JSON.stringify(input))

        history('/search')    

    }
    
    return (
        <form className='search'>
            <div className='search__input'>
                <SearchIcon className="search__input--icon" />
                <input  value={input} onChange={event=> setInput(event.target.value)}></input>
                <MicIcon className='mic__input--icon'/>
            </div>
            { !hideButtons ? 
            <><div className='search__buttons'>
                <button type='submit' onClick={search}>Google Search</button>
                <button>I'm Feeling Lucky</button>
            </div></> 
            : 
            <><div className='search__buttons'>
                <button type='submit' className='search__buttons--hidden' onClick={search}>Google Search</button>
                <button className='search__buttons--hidden'>I'm Feeling Lucky</button>
            </div></>}
            
        </form>
    );
}

export default Search;
